export default "__VITE_ASSET__883d72c2__"